import React, {useContext} from "react";

const BottomDrawerContext = React.createContext({});

export const BottomDrawerProvider = BottomDrawerContext.Provider;
export const BottomDrawerConsumer = BottomDrawerContext.Consumer;

export function useBottomDrawer(): {open: boolean, setOpen: () => any} {
  return useContext(BottomDrawerContext);
}